@if (
  {
    picture: picture$ | async,
    name: name$ | async
  };
  as resolved
) {
  <div class="flex min-w-0 items-center gap-2">
    <div
      [ngClass]="{
        'size-6': size === 'md',
        'size-10': size === 'lg'
      }">
      @if (resolved.picture) {
        <img
          class="size-full rounded-md border bg-slate-200"
          [src]="resolved.picture" />
      } @else {
        <div
          class="flex size-full items-center justify-center rounded-md border bg-slate-200"
          [style.background-color]="color?.bg"
          [style.color]="color?.text">
          <svg-icon
            size="lg"
            [key]="icon"></svg-icon>
        </div>
      }
    </div>
    @if (resolved.name && showName) {
      <div class="truncate">{{ resolved.name }}</div>
    }
  </div>
} @else {
  -
}
